export const submit_google_review_url =
  process.env.REACT_APP_COUNTRY == "JO"
    ? "https://search.google.com/local/writereview?placeid=ChIJZSc4rVqhHBUR_QKuzfUcjVw"
    : "https://search.google.com/local/writereview?placeid=ChIJWwkAUAUXHxURlFuIZ-qq87k";